import { OperationVariables, QueryResult, useQuery } from '@apollo/client';
import GET_CHECKLISTS from 'graph/queries/checklists/get-checklists-query';
import { Checklist } from 'types';

export type ChecklistStoreState = {
  checklists?: Checklist[];
  isLoading: boolean;
};

export type ChecklistStoreDispatch = {
  checklistRefetch: any;
};
export type ChecklistStore = [ChecklistStoreState, ChecklistStoreDispatch];

const useChecklistsStore = (variables?: OperationVariables): ChecklistStore => {
  const {
    data,
    loading,
    refetch: checklistRefetch,
  }: QueryResult<{ checklists: Checklist[] }> = useQuery(GET_CHECKLISTS, { variables });

  return [
    {
      checklists: data?.checklists,
      isLoading: loading,
    },
    {
      checklistRefetch,
    },
  ];
};

export default useChecklistsStore;
